__turbopack_context__.v({
  "card": "z7mQJG_card",
  "cell": "z7mQJG_cell",
  "eyebrow": "z7mQJG_eyebrow",
  "gradient": "z7mQJG_gradient",
  "grid": "z7mQJG_grid",
  "head": "z7mQJG_head",
  "hideOnPhone": "z7mQJG_hideOnPhone",
  "inner": "z7mQJG_inner",
  "logo": "z7mQJG_logo",
  "logo_engadget": "z7mQJG_logo_engadget",
  "logo_techAdvisor": "z7mQJG_logo_techAdvisor",
  "logo_trustedReviews": "z7mQJG_logo_trustedReviews",
  "logo_wareable": "z7mQJG_logo_wareable",
  "logo_yahooTech": "z7mQJG_logo_yahooTech",
  "mark": "z7mQJG_mark",
  "quote": "z7mQJG_quote",
  "read": "z7mQJG_read",
  "readIcon": "z7mQJG_readIcon",
  "section": "z7mQJG_section",
  "shader": "z7mQJG_shader",
  "srOnly": "z7mQJG_srOnly",
  "title": "z7mQJG_title",
  "top": "z7mQJG_top",
});
